import WebOrganisationListResultModelBase from '../_generated/modelBases/web-organisation-list-result-model-base';

export default class WebOrganisationListResultModel extends WebOrganisationListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
